module.exports = __webpack_public_path__ + "assets/img/5_1155.0dd57b64.jpg";